import { useState } from 'react';
import axios from 'axios';
import useGlobalStore from '../store/useGlobalStore';
import { cn } from '../utils/cn';

const ImageUploader = () => {
  const [image, setImage] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);
  const { setCloudImageUrl } = useGlobalStore();

  const uploadImage = async e => {
    e.preventDefault();
    if (!image) return;

    setUploading(true);
    const formData = new FormData();
    formData.append('file', image);
    formData.append('upload_preset', 'home-deco'); // Create unsigned preset in Cloudinary

    try {
      const res = await axios.post(
        `https://api.cloudinary.com/v1_1/djoszgmnc/image/upload`,
        formData
      );
      setCloudImageUrl(res.data.secure_url); // Store URL in global state
    } catch (err) {
      console.error('Upload failed:', err);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <input
        type="file"
        className=" text-lg text-center w-full rounded-[2px] mb-4 h-[40px] cursor-pointer p-2"
        onChange={e => {
          if (e.target.files && e.target.files[0]) {
            setImage(e.target.files[0]);
          } else {
            setImage(null);
          }
        }}
        accept="image/*"
      />
      <button
        className={cn(
          `bg-[#1A5EF9] px-4 py-2 rounded-[8px] text-white disabled:cursor-not-allowed disabled:bg-gray-400 disabled:text-gray-600`
        )}
        onClick={uploadImage}
        disabled={uploading || !image}
      >
        {uploading ? 'Uploading...' : 'Upload'}
      </button>
    </div>
  );
};

export default ImageUploader;
